import gql from "graphql-tag"

export const MONEY_FRAGMENT = gql`
  fragment MoneyFragment on MoneyV2 {
    amount
    currencyCode
  }
`
